import { render, staticRenderFns } from "./SmsOpportunityOfferDeliverance.vue?vue&type=template&id=52334f40&scoped=true&lang=pug&"
import script from "./SmsOpportunityOfferDeliverance.vue?vue&type=script&lang=js&"
export * from "./SmsOpportunityOfferDeliverance.vue?vue&type=script&lang=js&"
import style0 from "./SmsOpportunityOfferDeliverance.vue?vue&type=style&index=0&id=52334f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52334f40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VChip,VCol,VDivider,VForm,VIcon,VRadio,VRadioGroup,VRow,VTextField,VTextarea})
